// extracted by mini-css-extract-plugin
export default {"button":"Button_button__YhDVJ","button__label":"Button_button__label__uenWI"};